import React from "react";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import AboutUsView from "./AboutUsView";
import { Container, Row, Col } from "reactstrap";


function AboutUs() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader page={'aboutus'}/>
        <div className="main">
          
          <div className="section padding-0">
            <AboutUsView />
          </div>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default AboutUs;
